export default function HowWeHelp() {
    return (
        <div className="how-we-help">
            <p className="fs-1 fw-bold">How we can help you</p>
            <p className="fw-light">
                At Design Hive, we're the buzzing force behind captivating and
                purposeful digital experiences. Like industrious bees,{" "}
                <span className="fw-bold">
                    we blend artistry, strategy, and innovation
                </span>{" "}
                to sweeten your online presence.
            </p>
            <p className="fw-light">
                Join us at Design Hive, where creativity thrives and exceptional
                design takes flight. Let's create a digital ecosystem as sweet
                as honey.
            </p>
            <p className="fw-light">
                Our services include but are not limited to:
            </p>
            <ul className="fw-light">
                <li>UX Design</li>
                <li>Development</li>
                <li>Marketing</li>
            </ul>
            <button className="all-services-btn fw-bold">
                See All Services
            </button>
        </div>
    )
}
